interface IconProps {
  className?: string;
}

export function BookIcon({ className }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor">
      {/* Three books - left upright, middle tilted (shorter), right upright */}
      {/* Left book - tall */}
      <path d="M3 5.5C3 4.67 3.67 4 4.5 4h2C7.33 4 8 4.67 8 5.5v13c0 .83-.67 1.5-1.5 1.5h-2C3.67 20 3 19.33 3 18.5v-13z" />
      {/* Left book spine highlight */}
      <path d="M4.5 6h1v12h-1z" fill="currentColor" opacity="0.4" />
      {/* Middle tilted book - shorter, bottom aligned */}
      <path d="M8.2 19.4l1.8-11c.12-.75.82-1.25 1.55-1.12l1.7.28c.73.12 1.23.8 1.1 1.55l-1.8 11c-.12.75-.82 1.25-1.55 1.12l-1.7-.28c-.73-.12-1.23-.8-1.1-1.55z" />
      {/* Middle book spine highlight */}
      <path d="M10 10l.8.13-1.4 8.5-.8-.13z" fill="currentColor" opacity="0.4" />
      {/* Right book - tall */}
      <path d="M15 5.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v13c0 .83-.67 1.5-1.5 1.5h-2c-.83 0-1.5-.67-1.5-1.5v-13z" />
      {/* Right book spine highlight */}
      <path d="M16.5 6h1v12h-1z" fill="currentColor" opacity="0.4" />
    </svg>
  );
}
